import create from 'zustand';

import { StorageE } from 'declarations/enums/storage';

type AuthStoreState = {
  isUserLoggedIn: boolean;
  setUserLoginStatus: (isUserLoggedIn: boolean) => void;
};

const hasToken = !!localStorage.getItem(StorageE.IdToken);

const useAuthStore = create<AuthStoreState>(set => ({
  isUserLoggedIn: hasToken,
  setUserLoginStatus: (isUserLoggedIn: boolean): void => set({ isUserLoggedIn }),
}));

export default useAuthStore;
